import React, { Fragment, useEffect, useState } from 'react';
import { connect } from "react-redux";
import cx from "classnames";
import { Modal, ModalBody, Button } from "reactstrap";
import AppSidebar from '../../Layout/AppSidebar';
import AppHeader from '../../Layout/AppHeader';
import Loading from '../../Common/Loading';
import { 
    processValidLicense,
    getHeaderNotification, 
    isMobile,
    setLicenseErrorStatus,checkIsPageNotFound,translateContent, clearLegacyCookie, clearSessionValue, getLogoutURL, setCookie, getLicenseErrorStatus, getPaymentDetails, checkIsAgencyView,
    customConfirmBox
} from '../../Common/Appcommon';
import offer from "../../assets/utils/images/donot_miss.png";
import noAccessImag from '../../assets/utils/images/403.jpg';
import parseHtml from 'html-react-parser';
import { useAppContext } from '../../Context/AppContext';

const Common = (props) => {
    const useThemeFunc = useAppContext();
    const { showHeaderNoti, setShowHeaderNoti, headerNotiContent, setHeaderNotiContent, showPopupNoti, headerNotiMinutes } = useThemeFunc;
    const [notification, setNotification] = useState({ show: false });
    const [modal, setModal] = useState(false);

    const toggle = () => setModal(!modal); 
    let isAgencyView = checkIsAgencyView();

    let { mainContent, titleContent, title, titleBody, mainLoader, demoPopup, demoHandler, mobileViewNeedLeftMenu = false,titleKey = "",subAccountView=false, isMinimized } = props;
    const [isRedirectNeeded, setIsRedirectNeeded] = useState(false);
    if (title !== undefined && title !== "") {
        document.title = title;
    }
    useEffect(async() => {
        if(!isAgencyView && titleKey !== "" && titleKey !== undefined && titleKey !== null){
            let isPageNotFound = await checkIsPageNotFound(titleKey);
            if (isPageNotFound) {
                setIsRedirectNeeded(isPageNotFound);
                return;
            }
        }
        if(subAccountView){
            setIsRedirectNeeded(subAccountView);
            return;
        }
        async function getNotification() {
            let header_noti = getLicenseErrorStatus("header_noti");
            if(header_noti && !isAgencyView){
                let headernotification = await getHeaderNotification(showHeaderNoti, headerNotiContent);
                if(headernotification.show){
                    setNotification(headernotification);
                }else{
                    processAddonError();
                }
            }
        }
        getNotification();
        processAddonError();
    }, []);

    useEffect(() => {
        processValidLicense(useThemeFunc, toggle);
    }, [showPopupNoti])

    useEffect(() => {
        let header_noti = getLicenseErrorStatus("header_noti");
        if(header_noti && !isAgencyView){
            let message = "<p className='notification-text'>" + headerNotiContent + "</p>";
            message = parseHtml(message);
            setNotification(prev => ({
                ...prev,
                text: message,
                show: showHeaderNoti
            }));
        }
    }, [headerNotiContent])

    const processAddonError = () => {
        if(headerNotiMinutes !== ""){
            let noti = {};
            noti.show = true;
            noti.text = parseHtml(headerNotiMinutes);
            setNotification(noti);
        }
    }
    
    /* const customConfirmBox = () => {
        const redirectPage = () => {
            window.location.hash = "#/subscription";
            toggle();
        }
        return (
            <div className=''>
              <Modal isOpen={modal} className='agency-trial-end-popup' centered>
                <ModalBody>
                    <img src={offer} width={200} height={150} className='mb-3'></img>
                    <h3>Your FREE Trial Has Ended!</h3>
                    <p>Unlock Voicemetrics for a one-time price – No recurring fees, ever!</p>
                    <Button className='buy-btn' onClick={e => redirectPage()}>
                        Buy Lifetime Deal
                    </Button>
                    <p className="mt-2">🔥 Claim your discount before it's gone! 🔥</p>
                </ModalBody>
              </Modal>
            </div>
          );
    } */

    const oncloseAction = () => {
        setHeaderNotiContent("");
        setShowHeaderNoti(false);
        setNotification(false);
        setLicenseErrorStatus("header_noti", "false");
    }

    // let loaderType = "ball-clip-rotate";
    return (
        <Fragment>
            <div className={cx('header-notification', {
                    'hide': !notification.show
                }, { "mobile-header": isMobile() })}>
                <div className={'header-notification-body'}>
                    <>
                        {/* {notification.icon && <FontAwesomeIcon icon={faInfoCircle} />} */}
                        {notification.text}
                    </>
                </div>
                <button type="button" className="btn-close" aria-label="Close" onClick={(e) => { oncloseAction(e) }} ></button>
            </div>
            {!isRedirectNeeded && titleContent && <AppHeader isMinimized={isMinimized} titleContent={titleContent} titleBody={titleBody} headerNotifyShow={notification.show} demoPopup={demoPopup} demoHandler={demoHandler} mobileViewNeedLeftMenu={mobileViewNeedLeftMenu}/>}
            <div className="app-main">
                {isRedirectNeeded ? (
                    <>
                    <div className='no-records-container'>
                    <div className='d-grid align-center'>
                        <img src={noAccessImag} alt={"Forbidden"}/>
                    </div>
                </div>
                </>) :(
                    <>
                        <AppSidebar useThemeFunc={useThemeFunc}/>
                        <div className="app-main__outer">
                            <Loading showLoader={mainLoader} mainContent={ 
                                <div className="app-main__inner app-normal__inner">
                                    <div className={`app-main-content ${!notification.show ? "" : "header-msg"}`}>
                                        {mainContent}
                                    </div>
                                </div>
                            } />

                        </div>
                    </>)
                }
                {
                    customConfirmBox(toggle, modal)
                }
            </div>
        </Fragment>
    )
}

const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(Common);
